<script>

import appConfig from '@src/app.config'
import Layout from '@layouts/main'

import Widget from '../../dashboard/widget.vue'

export default {
  page: {
    title: 'Palo Alto Networks Cortex Stats',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: {
    Layout,
    Widget
  },
  props: {
    name: {
      type: String,
      default: 'main.json'
    }
  },
  data () {
    return {
      dashboard: {
        'widgets': [
          {
            'name': 'DISTRIBUCCIÓN DIARIA DE INCIDENTES NUEVOS EN CORTEX',
            'series': [
              {
                'name': 'Incidentes Nuevos en Cortex',
                'type': 'column',
                'source': '/pan/xdr/incidents/stats?base=no',
                'labelsSource': true,
                'color': '#0084FF'
              }
            ],
            'cols': 'col-md-12',
            'height_class': 'tall_widget',
            'cardStyle': 'height:360px;',
            'component': 'mixed',
            'refresh': 60000
          },
          {
            'name': 'ALARMAS POR BAJO NIVEL DE INCIDENTES DETECTADOS EN CORTEX',
            'source': '/pan/xdr/incidents/stats/alarms',
            'cols': 'col-md-12',
            'height_class': 'tall_widget',
            'cardStyle': 'height:360px;',
            'component': 'owntable',
            'refresh': 60000
          }
        ]
      },
      appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev')
    }
  },
  computed: {

  },
  mounted () {

    // console.log(this.jsonDef)
  },
  methods: {

  }
}
</script>

<template>
  <Layout>
    <div
      class="container"
      style="max-width: 1420px !important;"
    >
      <div class="row page-title align-items-center" />
      <div class="row">
        <template v-for="(widget, index) in dashboard.widgets">
          <Widget
            :key="index"
            :title="widget.name"
            :component="widget.component"
            :source="widget.source"
            :series="widget.series"
            :cols="widget.cols"
            :trend="widget.trend"
            :wclass="widget.class"
            :type="widget.type"
            :card-style="widget.cardStyle"
            :categories="widget.categories"
            :colors="widget.colors"
            :colors-by-label="widget.colorsByLabel"
            :range="widget.range"
            :start="startEpoch"
            :end="endEpoch"
          />
        </template>
      </div>
    </div>
  </Layout>
</template>
